import { render, staticRenderFns } from "./index.vue?vue&type=template&id=588c5fe4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=588c5fe4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c5fe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588c5fe4')) {
      api.createRecord('588c5fe4', component.options)
    } else {
      api.reload('588c5fe4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=588c5fe4&scoped=true", function () {
      api.rerender('588c5fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/BoxWrap/index.vue"
export default component.exports